import { render } from "./InnovationPost.vue?vue&type=template&id=2bfd6a2f&scoped=true"
import script from "./InnovationPost.vue?vue&type=script&lang=js"
export * from "./InnovationPost.vue?vue&type=script&lang=js"

import "./InnovationPost.vue?vue&type=style&index=0&id=2bfd6a2f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2bfd6a2f"

export default script